import React from "react";
import BrandIcon from "../../components/BrandIcon";
import ClientAccessLabel from "../../components/ClientAccessLabel";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  client: server.dto.Client
}

const AdminOneClientCard = (props: Props) => {
  return (<div className="padding-large panel-bg-color flex hoverable" onClick={() => window.document.location.href = routes.client_DetailAdminOne(props.client.clientId).absolute}>
    <div className="grow1 margin-right">
      <div className="margin-bottom-large">
        <h2>{props.client.name}</h2>
      </div>
      <div>
        <ClientAccessLabel access={props.client.access} />

        <span className="s1_gray padding-left">
          Client {props.client.clientId}
        </span>
      </div>
    </div>
    <div>
      <BrandIcon name={props.client.name} iconUrl={props.client.iconUrl} size={60} />
    </div>
  </div >);
};

export default AdminOneClientCard;